import { AxiosResponse } from 'axios';
import { apiClient } from "@store/services/checkoutClient";
import { PpsPayload } from "@store/checkout/interfaces/ppsPayload";

export async function ppsGatewayMiddleware(apiEndpoint: string, payload: PpsPayload): Promise<AxiosResponse> {
    return await apiClient.post(apiEndpoint, payload);
}
